var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00018 8.81698C0.991382 8.01256 1.30252 7.2376 1.86514 6.6626C2.42776 6.08761 3.19576 5.75968 4.00018 5.75098H10.0002C10.8046 5.75968 11.5726 6.08761 12.1352 6.6626C12.6978 7.2376 13.009 8.01256 13.0002 8.81698V13.927C13.018 15.6017 11.6749 16.9738 10.0002 16.992H4.00018C3.19576 16.9833 2.42776 16.6553 1.86514 16.0803C1.30252 15.5054 0.991382 14.7304 1.00018 13.926V8.81698Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.69222 2.837L8.11422 4.498L8.28322 5.06L8.52322 4.115C8.61436 3.70798 8.8671 3.35553 9.22337 3.13864C9.57964 2.92175 10.0088 2.85907 10.4122 2.965C11.2519 3.22815 11.7337 4.10774 11.5032 4.957C11.4061 5.39935 11.0273 5.72353 10.5752 5.751H5.00322C4.07857 5.70804 3.30521 5.03409 3.13622 4.124C2.78051 2.82513 3.51757 1.4779 4.80322 1.077C5.42037 0.914977 6.07689 1.01099 6.6218 1.34295C7.16672 1.67492 7.55314 2.21427 7.69222 2.837Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    d: "M9.01049 5.23425C9.10669 4.83136 8.85808 4.42677 8.45519 4.33057C8.0523 4.23436 7.64771 4.48298 7.55151 4.88587L9.01049 5.23425ZM7.38651 5.57687C7.29031 5.97975 7.53892 6.38435 7.94181 6.48055C8.3447 6.57675 8.74929 6.32814 8.84549 5.92525L7.38651 5.57687ZM7.75 5.75106C7.75 5.33685 7.41421 5.00106 7 5.00106C6.58579 5.00106 6.25 5.33685 6.25 5.75106H7.75ZM6.25 16.9921C6.25 17.4063 6.58579 17.7421 7 17.7421C7.41421 17.7421 7.75 17.4063 7.75 16.9921H6.25ZM7.55151 4.88587L7.38651 5.57687L8.84549 5.92525L9.01049 5.23425L7.55151 4.88587ZM6.25 5.75106V16.9921H7.75V5.75106H6.25Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.7837a140d86bdeff4a07a86567746d16.svg";
export { ForwardRef as ReactComponent };